const transformCatalogReviewsResponse = (data)=>data.map((item)=>transformPostCatalogReviewsResponse(item));
const transformCatalogRatingResponse = ({ rating_summary , reviews_count  })=>({
        valuePercent: parseInt(rating_summary),
        count: parseInt(reviews_count)
    });
const transformPostCatalogReviewsResponse = ({ id , title , detail , nickname , created_at , ratings , entity_pk_value  })=>({
        id,
        title,
        description: detail,
        user: nickname,
        createdDate: created_at,
        value: ratings[0]?.value || null,
        percent: ratings[0]?.percent || null,
        productId: entity_pk_value
    });

export { transformCatalogRatingResponse, transformCatalogReviewsResponse, transformPostCatalogReviewsResponse };
